import { urls } from "app/api/urls";
import cloneDeep from "lodash/cloneDeep";
import ENV from "../../config";
import { SessionHelper } from "../helpers/sessionHelper";
import store from "../store/store";

export class CompetitionAPIHelper {
  // get competitionListModel from store
  static getCompetitionListModelData(): any {
    return cloneDeep(store.getState().competitionListModel);
  }

  static getCompetitionListUrl(): string {
    if (store.getState().competitionListModel.futures) {
      return urls.data.API_FUTURES();
    } else {
      return window.location.pathname.includes("/asian/")
        ? urls.data.API_ASIAN_COMPETITIONS()
        : urls.data.API_COMPETITIONS();
    }
  }

  static getSingleCompetitionListUrl(competitionId: string): string {
    if (SessionHelper.isAsianRouteAndSessionView() === true) {
      return urls.data.API_SINGLE_COMPETITION_ASIAN(competitionId); // Seems to be not used, asian single competition uses nav node id
    } else return urls.data.API_SINGLE_COMPETITION(competitionId);
  }

  static getSingleCompetitionListAsianViewParams(params: any): any {
    if (SessionHelper.isAsianRouteAndSessionView() === true) {
      params.live = true;
      params.nonLive = true;
    }

    return params;
  }

  static getDatesWithEventsUrl(): string {
    return `${ENV.API_HOST_V3}/${urls.data.API_DAYS_WITH_EVENTS()}`;
  }

  static getNumberOfLiveEventsUrl(): string {
    return urls.data.API_LIVE_COUNT();
  }

  static getNumberOfFutureEventsUrl(): string {
    return urls.data.API_FUTURES_COUNT();
  }
}
